import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sabadabadoo from './pages/Sabadabadoo';

function App() {
  return (
      <Router>
          <Routes>
              <Route path="/" element={<Sabadabadoo />} />
          </Routes>
      </Router>
  );
}

export default App;
